<template>
  <!-- Sidebar Filter -->
  <aside
    data-scroll-lock-scrollable
    :class="
      twJoin(
        'fixed z-50 lg:z-10 pb-[86px] lg:pb-0 top-0 left-0 w-full lg:w-auto lg:relative overflow-scroll lg:overflow-visible h-screen lg:!h-auto bg-primary-white lg:bg-transparent',
        !isFilterOpen && 'hidden lg:!block'
      )
    "
    :style="{ height: `${appHeight}px` }"
  >
    <div class="lg:bg-gray-10 absolute w-screen right-0 h-screen lg:h-full" />
    <div class="relative lg:w-[200px] px-5 lg:px-0 py-5 lg:py-10 lg:pr-6">
      <!-- Mobile Header -->
      <header
        class="lg:hidden mb-2 border-b pb-5 px-5 -mx-5 flex items-center justify-between"
      >
        <h2 class="text-xl font-bold">
          {{ $t('products.filterBy') }}
        </h2>
        <button
          class="cursor-pointer"
          @click="$emit('close')"
          aria-label="Close filter panel"
        >
          <Icon name="times" />
        </button>
      </header>

      <!-- Product Type Navigation -->
      <nav
        aria-label="Product Type Navigation"
        class="*:font-bold hidden lg:flex flex-col gap-y-2 *:cursor-pointer mb-4"
      >
        <button
          v-for="productTypeOption in productTypeOptions"
          :key="productTypeOption.value"
          class="hover:opacity-50 text-left"
          @click="() => router.push(productTypeOption.href)"
        >
          {{ $t(productTypeOption.label) }}
        </button>
      </nav>

      <!-- Facets -->
      <ProductListFacetTreeComponent :facet-data="facetData" />

      <!-- Mobile Bottom Buttons -->
      <div
        class="lg:hidden fixed bottom-0 left-0 w-screen grid grid-cols-2 px-5 py-4 gap-x-2 bg-primary-white shadow-cc"
      >
        <Button intent="secondary" @click="$emit('clearAllFilter')">
          {{ $t('products.clearAll') }}
        </Button>
        <Button @click="$emit('close')">
          {{ $t('products.apply') }}
        </Button>
      </div>
    </div>
  </aside>
</template>

<script setup lang="ts">
import { twJoin } from 'tailwind-merge'

// Emits and props
defineEmits<{
  (e: 'close'): void
  (e: 'clearAllFilter'): void
}>()

defineProps<{
  isFilterOpen: boolean
  facetData: any
}>()

const ProductListFacetTreeComponent = defineAsyncComponent(
  () => import('../v2/ProductListFacetTree.vue')
)

// Composables
const router = useRouter()
const localePath = useLocalePath()

const appHeight = ref<number>(0)
const productTypeOptions = [
  {
    label: 'products.allPhone', // ใช้กับ $t() หรือ v-t
    value: 'all-phones',
    href: localePath('/products/cases')
  },
  {
    label: 'products.allEarbud',
    value: 'all-earbuds',
    href: localePath('/products/airpods')
  },
  {
    label: 'products.allAccessories',
    value: 'accessories',
    href: localePath('/products/accessories')
  }
]

const getAppHeight = () => {
  appHeight.value = window.innerHeight
}

onMounted(() => {
  let timer: NodeJS.Timeout
  getAppHeight()
  window.addEventListener('resize', () => {
    clearTimeout(timer)
    timer = setTimeout(getAppHeight, 200)
  })
})

onUnmounted(() => {
  window.removeEventListener('resize', getAppHeight)
})
</script>
